/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RegisterImport } from './routes/register'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout/index'
import { Route as VKeyImport } from './routes/v/$key'
import { Route as SSlugImport } from './routes/s/$slug'
import { Route as PublicProjectIdImport } from './routes/public/$projectId'
import { Route as PAliasImport } from './routes/p/$alias'
import { Route as LiveSlugImport } from './routes/live/$slug'
import { Route as InviteTokenImport } from './routes/invite/$token'
import { Route as LayoutProfileImport } from './routes/_layout/profile'
import { Route as LayoutOrganizationImport } from './routes/_layout/organization'
import { Route as LayoutHelpImport } from './routes/_layout/help'
import { Route as LayoutDownloadImport } from './routes/_layout/download'
import { Route as LayoutBillingImport } from './routes/_layout/billing'
import { Route as LayoutProjectsRouteImport } from './routes/_layout/projects/route'
import { Route as LayoutProjectsIndexImport } from './routes/_layout/projects/index'
import { Route as LayoutProjectsNewImport } from './routes/_layout/projects/new'
import { Route as LayoutProjectsProjectIdRouteImport } from './routes/_layout/projects/$projectId/route'
import { Route as LayoutProjectsProjectIdIndexImport } from './routes/_layout/projects/$projectId/index'
import { Route as LayoutOrganizationsOrganizationIdIndexImport } from './routes/_layout/organizations/$organizationId/index'
import { Route as LayoutAdminUsersIndexImport } from './routes/_layout/admin/users/index'
import { Route as LayoutAdminOrganizationsIndexImport } from './routes/_layout/admin/organizations/index'
import { Route as LayoutProjectsProjectIdSubmissionsImport } from './routes/_layout/projects/$projectId/submissions'
import { Route as LayoutProjectsProjectIdSettingsImport } from './routes/_layout/projects/$projectId/settings'
import { Route as LayoutProjectsProjectIdGalleriesImport } from './routes/_layout/projects/$projectId/galleries'
import { Route as LayoutProjectsProjectIdEmailsImport } from './routes/_layout/projects/$projectId/emails'
import { Route as LayoutProjectsProjectIdAnalyticsImport } from './routes/_layout/projects/$projectId/analytics'
import { Route as LayoutOrganizationsOrganizationIdWebhooksImport } from './routes/_layout/organizations/$organizationId/webhooks'
import { Route as LayoutOrganizationsOrganizationIdMembersImport } from './routes/_layout/organizations/$organizationId/members'
import { Route as LayoutAdminUsersUserIdImport } from './routes/_layout/admin/users/$userId'
import { Route as LayoutAdminOrganizationsOrgIdImport } from './routes/_layout/admin/organizations/$orgId'
import { Route as LayoutProjectsProjectIdVideosIndexImport } from './routes/_layout/projects/$projectId/videos/index'
import { Route as LayoutProjectsProjectIdVideosVideoIdImport } from './routes/_layout/projects/$projectId/videos/$videoId'
import { Route as LayoutProjectsProjectIdPurchaseOptionsCallbackImport } from './routes/_layout/projects/$projectId/purchase/options-callback'
import { Route as LayoutProjectsProjectIdPurchaseCallbackImport } from './routes/_layout/projects/$projectId/purchase/callback'

// Create/Update Routes

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/logout.lazy').then((d) => d.Route))

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const VKeyRoute = VKeyImport.update({
  id: '/v/$key',
  path: '/v/$key',
  getParentRoute: () => rootRoute,
} as any)

const SSlugRoute = SSlugImport.update({
  id: '/s/$slug',
  path: '/s/$slug',
  getParentRoute: () => rootRoute,
} as any)

const PublicProjectIdRoute = PublicProjectIdImport.update({
  id: '/public/$projectId',
  path: '/public/$projectId',
  getParentRoute: () => rootRoute,
} as any)

const PAliasRoute = PAliasImport.update({
  id: '/p/$alias',
  path: '/p/$alias',
  getParentRoute: () => rootRoute,
} as any)

const LiveSlugRoute = LiveSlugImport.update({
  id: '/live/$slug',
  path: '/live/$slug',
  getParentRoute: () => rootRoute,
} as any)

const InviteTokenRoute = InviteTokenImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/invite/$token.lazy').then((d) => d.Route))

const LayoutProfileRoute = LayoutProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/profile.lazy').then((d) => d.Route),
)

const LayoutOrganizationRoute = LayoutOrganizationImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutHelpRoute = LayoutHelpImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() => import('./routes/_layout/help.lazy').then((d) => d.Route))

const LayoutDownloadRoute = LayoutDownloadImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/download.lazy').then((d) => d.Route),
)

const LayoutBillingRoute = LayoutBillingImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/billing.lazy').then((d) => d.Route),
)

const LayoutProjectsRouteRoute = LayoutProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutProjectsIndexRoute = LayoutProjectsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutProjectsRouteRoute,
} as any).lazy(() =>
  import('./routes/_layout/projects/index.lazy').then((d) => d.Route),
)

const LayoutProjectsNewRoute = LayoutProjectsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => LayoutProjectsRouteRoute,
} as any).lazy(() =>
  import('./routes/_layout/projects/new.lazy').then((d) => d.Route),
)

const LayoutProjectsProjectIdRouteRoute =
  LayoutProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => LayoutProjectsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/route.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutProjectsProjectIdIndexRoute =
  LayoutProjectsProjectIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutOrganizationsOrganizationIdIndexRoute =
  LayoutOrganizationsOrganizationIdIndexImport.update({
    id: '/organizations/$organizationId/',
    path: '/organizations/$organizationId/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/organizations/$organizationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutAdminUsersIndexRoute = LayoutAdminUsersIndexImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/admin/users/index.lazy').then((d) => d.Route),
)

const LayoutAdminOrganizationsIndexRoute =
  LayoutAdminOrganizationsIndexImport.update({
    id: '/admin/organizations/',
    path: '/admin/organizations/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/admin/organizations/index.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutProjectsProjectIdSubmissionsRoute =
  LayoutProjectsProjectIdSubmissionsImport.update({
    id: '/submissions',
    path: '/submissions',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/submissions.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutProjectsProjectIdSettingsRoute =
  LayoutProjectsProjectIdSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/settings.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutProjectsProjectIdGalleriesRoute =
  LayoutProjectsProjectIdGalleriesImport.update({
    id: '/galleries',
    path: '/galleries',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/galleries.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutProjectsProjectIdEmailsRoute =
  LayoutProjectsProjectIdEmailsImport.update({
    id: '/emails',
    path: '/emails',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/emails.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutProjectsProjectIdAnalyticsRoute =
  LayoutProjectsProjectIdAnalyticsImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/analytics.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutOrganizationsOrganizationIdWebhooksRoute =
  LayoutOrganizationsOrganizationIdWebhooksImport.update({
    id: '/organizations/$organizationId/webhooks',
    path: '/organizations/$organizationId/webhooks',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/organizations/$organizationId/webhooks.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutOrganizationsOrganizationIdMembersRoute =
  LayoutOrganizationsOrganizationIdMembersImport.update({
    id: '/organizations/$organizationId/members',
    path: '/organizations/$organizationId/members',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/organizations/$organizationId/members.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutAdminUsersUserIdRoute = LayoutAdminUsersUserIdImport.update({
  id: '/admin/users/$userId',
  path: '/admin/users/$userId',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/admin/users/$userId.lazy').then((d) => d.Route),
)

const LayoutAdminOrganizationsOrgIdRoute =
  LayoutAdminOrganizationsOrgIdImport.update({
    id: '/admin/organizations/$orgId',
    path: '/admin/organizations/$orgId',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/admin/organizations/$orgId.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutProjectsProjectIdVideosIndexRoute =
  LayoutProjectsProjectIdVideosIndexImport.update({
    id: '/videos/',
    path: '/videos/',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/videos/index.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutProjectsProjectIdVideosVideoIdRoute =
  LayoutProjectsProjectIdVideosVideoIdImport.update({
    id: '/videos/$videoId',
    path: '/videos/$videoId',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/videos/$videoId.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutProjectsProjectIdPurchaseOptionsCallbackRoute =
  LayoutProjectsProjectIdPurchaseOptionsCallbackImport.update({
    id: '/purchase/options-callback',
    path: '/purchase/options-callback',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/projects/$projectId/purchase/options-callback.lazy'
    ).then((d) => d.Route),
  )

const LayoutProjectsProjectIdPurchaseCallbackRoute =
  LayoutProjectsProjectIdPurchaseCallbackImport.update({
    id: '/purchase/callback',
    path: '/purchase/callback',
    getParentRoute: () => LayoutProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/projects/$projectId/purchase/callback.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_layout/projects': {
      id: '/_layout/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof LayoutProjectsRouteImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/billing': {
      id: '/_layout/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof LayoutBillingImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/download': {
      id: '/_layout/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof LayoutDownloadImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/help': {
      id: '/_layout/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof LayoutHelpImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/organization': {
      id: '/_layout/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof LayoutOrganizationImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/profile': {
      id: '/_layout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof LayoutProfileImport
      parentRoute: typeof LayoutImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenImport
      parentRoute: typeof rootRoute
    }
    '/live/$slug': {
      id: '/live/$slug'
      path: '/live/$slug'
      fullPath: '/live/$slug'
      preLoaderRoute: typeof LiveSlugImport
      parentRoute: typeof rootRoute
    }
    '/p/$alias': {
      id: '/p/$alias'
      path: '/p/$alias'
      fullPath: '/p/$alias'
      preLoaderRoute: typeof PAliasImport
      parentRoute: typeof rootRoute
    }
    '/public/$projectId': {
      id: '/public/$projectId'
      path: '/public/$projectId'
      fullPath: '/public/$projectId'
      preLoaderRoute: typeof PublicProjectIdImport
      parentRoute: typeof rootRoute
    }
    '/s/$slug': {
      id: '/s/$slug'
      path: '/s/$slug'
      fullPath: '/s/$slug'
      preLoaderRoute: typeof SSlugImport
      parentRoute: typeof rootRoute
    }
    '/v/$key': {
      id: '/v/$key'
      path: '/v/$key'
      fullPath: '/v/$key'
      preLoaderRoute: typeof VKeyImport
      parentRoute: typeof rootRoute
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/projects/$projectId': {
      id: '/_layout/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof LayoutProjectsProjectIdRouteImport
      parentRoute: typeof LayoutProjectsRouteImport
    }
    '/_layout/projects/new': {
      id: '/_layout/projects/new'
      path: '/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof LayoutProjectsNewImport
      parentRoute: typeof LayoutProjectsRouteImport
    }
    '/_layout/projects/': {
      id: '/_layout/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof LayoutProjectsIndexImport
      parentRoute: typeof LayoutProjectsRouteImport
    }
    '/_layout/admin/organizations/$orgId': {
      id: '/_layout/admin/organizations/$orgId'
      path: '/admin/organizations/$orgId'
      fullPath: '/admin/organizations/$orgId'
      preLoaderRoute: typeof LayoutAdminOrganizationsOrgIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin/users/$userId': {
      id: '/_layout/admin/users/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof LayoutAdminUsersUserIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/organizations/$organizationId/members': {
      id: '/_layout/organizations/$organizationId/members'
      path: '/organizations/$organizationId/members'
      fullPath: '/organizations/$organizationId/members'
      preLoaderRoute: typeof LayoutOrganizationsOrganizationIdMembersImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/organizations/$organizationId/webhooks': {
      id: '/_layout/organizations/$organizationId/webhooks'
      path: '/organizations/$organizationId/webhooks'
      fullPath: '/organizations/$organizationId/webhooks'
      preLoaderRoute: typeof LayoutOrganizationsOrganizationIdWebhooksImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/projects/$projectId/analytics': {
      id: '/_layout/projects/$projectId/analytics'
      path: '/analytics'
      fullPath: '/projects/$projectId/analytics'
      preLoaderRoute: typeof LayoutProjectsProjectIdAnalyticsImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
    '/_layout/projects/$projectId/emails': {
      id: '/_layout/projects/$projectId/emails'
      path: '/emails'
      fullPath: '/projects/$projectId/emails'
      preLoaderRoute: typeof LayoutProjectsProjectIdEmailsImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
    '/_layout/projects/$projectId/galleries': {
      id: '/_layout/projects/$projectId/galleries'
      path: '/galleries'
      fullPath: '/projects/$projectId/galleries'
      preLoaderRoute: typeof LayoutProjectsProjectIdGalleriesImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
    '/_layout/projects/$projectId/settings': {
      id: '/_layout/projects/$projectId/settings'
      path: '/settings'
      fullPath: '/projects/$projectId/settings'
      preLoaderRoute: typeof LayoutProjectsProjectIdSettingsImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
    '/_layout/projects/$projectId/submissions': {
      id: '/_layout/projects/$projectId/submissions'
      path: '/submissions'
      fullPath: '/projects/$projectId/submissions'
      preLoaderRoute: typeof LayoutProjectsProjectIdSubmissionsImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
    '/_layout/admin/organizations/': {
      id: '/_layout/admin/organizations/'
      path: '/admin/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof LayoutAdminOrganizationsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin/users/': {
      id: '/_layout/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof LayoutAdminUsersIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/organizations/$organizationId/': {
      id: '/_layout/organizations/$organizationId/'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof LayoutOrganizationsOrganizationIdIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/projects/$projectId/': {
      id: '/_layout/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof LayoutProjectsProjectIdIndexImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
    '/_layout/projects/$projectId/purchase/callback': {
      id: '/_layout/projects/$projectId/purchase/callback'
      path: '/purchase/callback'
      fullPath: '/projects/$projectId/purchase/callback'
      preLoaderRoute: typeof LayoutProjectsProjectIdPurchaseCallbackImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
    '/_layout/projects/$projectId/purchase/options-callback': {
      id: '/_layout/projects/$projectId/purchase/options-callback'
      path: '/purchase/options-callback'
      fullPath: '/projects/$projectId/purchase/options-callback'
      preLoaderRoute: typeof LayoutProjectsProjectIdPurchaseOptionsCallbackImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
    '/_layout/projects/$projectId/videos/$videoId': {
      id: '/_layout/projects/$projectId/videos/$videoId'
      path: '/videos/$videoId'
      fullPath: '/projects/$projectId/videos/$videoId'
      preLoaderRoute: typeof LayoutProjectsProjectIdVideosVideoIdImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
    '/_layout/projects/$projectId/videos/': {
      id: '/_layout/projects/$projectId/videos/'
      path: '/videos'
      fullPath: '/projects/$projectId/videos'
      preLoaderRoute: typeof LayoutProjectsProjectIdVideosIndexImport
      parentRoute: typeof LayoutProjectsProjectIdRouteImport
    }
  }
}

// Create and export the route tree

interface LayoutProjectsProjectIdRouteRouteChildren {
  LayoutProjectsProjectIdAnalyticsRoute: typeof LayoutProjectsProjectIdAnalyticsRoute
  LayoutProjectsProjectIdEmailsRoute: typeof LayoutProjectsProjectIdEmailsRoute
  LayoutProjectsProjectIdGalleriesRoute: typeof LayoutProjectsProjectIdGalleriesRoute
  LayoutProjectsProjectIdSettingsRoute: typeof LayoutProjectsProjectIdSettingsRoute
  LayoutProjectsProjectIdSubmissionsRoute: typeof LayoutProjectsProjectIdSubmissionsRoute
  LayoutProjectsProjectIdIndexRoute: typeof LayoutProjectsProjectIdIndexRoute
  LayoutProjectsProjectIdPurchaseCallbackRoute: typeof LayoutProjectsProjectIdPurchaseCallbackRoute
  LayoutProjectsProjectIdPurchaseOptionsCallbackRoute: typeof LayoutProjectsProjectIdPurchaseOptionsCallbackRoute
  LayoutProjectsProjectIdVideosVideoIdRoute: typeof LayoutProjectsProjectIdVideosVideoIdRoute
  LayoutProjectsProjectIdVideosIndexRoute: typeof LayoutProjectsProjectIdVideosIndexRoute
}

const LayoutProjectsProjectIdRouteRouteChildren: LayoutProjectsProjectIdRouteRouteChildren =
  {
    LayoutProjectsProjectIdAnalyticsRoute:
      LayoutProjectsProjectIdAnalyticsRoute,
    LayoutProjectsProjectIdEmailsRoute: LayoutProjectsProjectIdEmailsRoute,
    LayoutProjectsProjectIdGalleriesRoute:
      LayoutProjectsProjectIdGalleriesRoute,
    LayoutProjectsProjectIdSettingsRoute: LayoutProjectsProjectIdSettingsRoute,
    LayoutProjectsProjectIdSubmissionsRoute:
      LayoutProjectsProjectIdSubmissionsRoute,
    LayoutProjectsProjectIdIndexRoute: LayoutProjectsProjectIdIndexRoute,
    LayoutProjectsProjectIdPurchaseCallbackRoute:
      LayoutProjectsProjectIdPurchaseCallbackRoute,
    LayoutProjectsProjectIdPurchaseOptionsCallbackRoute:
      LayoutProjectsProjectIdPurchaseOptionsCallbackRoute,
    LayoutProjectsProjectIdVideosVideoIdRoute:
      LayoutProjectsProjectIdVideosVideoIdRoute,
    LayoutProjectsProjectIdVideosIndexRoute:
      LayoutProjectsProjectIdVideosIndexRoute,
  }

const LayoutProjectsProjectIdRouteRouteWithChildren =
  LayoutProjectsProjectIdRouteRoute._addFileChildren(
    LayoutProjectsProjectIdRouteRouteChildren,
  )

interface LayoutProjectsRouteRouteChildren {
  LayoutProjectsProjectIdRouteRoute: typeof LayoutProjectsProjectIdRouteRouteWithChildren
  LayoutProjectsNewRoute: typeof LayoutProjectsNewRoute
  LayoutProjectsIndexRoute: typeof LayoutProjectsIndexRoute
}

const LayoutProjectsRouteRouteChildren: LayoutProjectsRouteRouteChildren = {
  LayoutProjectsProjectIdRouteRoute:
    LayoutProjectsProjectIdRouteRouteWithChildren,
  LayoutProjectsNewRoute: LayoutProjectsNewRoute,
  LayoutProjectsIndexRoute: LayoutProjectsIndexRoute,
}

const LayoutProjectsRouteRouteWithChildren =
  LayoutProjectsRouteRoute._addFileChildren(LayoutProjectsRouteRouteChildren)

interface LayoutRouteChildren {
  LayoutProjectsRouteRoute: typeof LayoutProjectsRouteRouteWithChildren
  LayoutBillingRoute: typeof LayoutBillingRoute
  LayoutDownloadRoute: typeof LayoutDownloadRoute
  LayoutHelpRoute: typeof LayoutHelpRoute
  LayoutOrganizationRoute: typeof LayoutOrganizationRoute
  LayoutProfileRoute: typeof LayoutProfileRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutAdminOrganizationsOrgIdRoute: typeof LayoutAdminOrganizationsOrgIdRoute
  LayoutAdminUsersUserIdRoute: typeof LayoutAdminUsersUserIdRoute
  LayoutOrganizationsOrganizationIdMembersRoute: typeof LayoutOrganizationsOrganizationIdMembersRoute
  LayoutOrganizationsOrganizationIdWebhooksRoute: typeof LayoutOrganizationsOrganizationIdWebhooksRoute
  LayoutAdminOrganizationsIndexRoute: typeof LayoutAdminOrganizationsIndexRoute
  LayoutAdminUsersIndexRoute: typeof LayoutAdminUsersIndexRoute
  LayoutOrganizationsOrganizationIdIndexRoute: typeof LayoutOrganizationsOrganizationIdIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutProjectsRouteRoute: LayoutProjectsRouteRouteWithChildren,
  LayoutBillingRoute: LayoutBillingRoute,
  LayoutDownloadRoute: LayoutDownloadRoute,
  LayoutHelpRoute: LayoutHelpRoute,
  LayoutOrganizationRoute: LayoutOrganizationRoute,
  LayoutProfileRoute: LayoutProfileRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutAdminOrganizationsOrgIdRoute: LayoutAdminOrganizationsOrgIdRoute,
  LayoutAdminUsersUserIdRoute: LayoutAdminUsersUserIdRoute,
  LayoutOrganizationsOrganizationIdMembersRoute:
    LayoutOrganizationsOrganizationIdMembersRoute,
  LayoutOrganizationsOrganizationIdWebhooksRoute:
    LayoutOrganizationsOrganizationIdWebhooksRoute,
  LayoutAdminOrganizationsIndexRoute: LayoutAdminOrganizationsIndexRoute,
  LayoutAdminUsersIndexRoute: LayoutAdminUsersIndexRoute,
  LayoutOrganizationsOrganizationIdIndexRoute:
    LayoutOrganizationsOrganizationIdIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof LayoutRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/projects': typeof LayoutProjectsRouteRouteWithChildren
  '/billing': typeof LayoutBillingRoute
  '/download': typeof LayoutDownloadRoute
  '/help': typeof LayoutHelpRoute
  '/organization': typeof LayoutOrganizationRoute
  '/profile': typeof LayoutProfileRoute
  '/invite/$token': typeof InviteTokenRoute
  '/live/$slug': typeof LiveSlugRoute
  '/p/$alias': typeof PAliasRoute
  '/public/$projectId': typeof PublicProjectIdRoute
  '/s/$slug': typeof SSlugRoute
  '/v/$key': typeof VKeyRoute
  '/': typeof LayoutIndexRoute
  '/projects/$projectId': typeof LayoutProjectsProjectIdRouteRouteWithChildren
  '/projects/new': typeof LayoutProjectsNewRoute
  '/projects/': typeof LayoutProjectsIndexRoute
  '/admin/organizations/$orgId': typeof LayoutAdminOrganizationsOrgIdRoute
  '/admin/users/$userId': typeof LayoutAdminUsersUserIdRoute
  '/organizations/$organizationId/members': typeof LayoutOrganizationsOrganizationIdMembersRoute
  '/organizations/$organizationId/webhooks': typeof LayoutOrganizationsOrganizationIdWebhooksRoute
  '/projects/$projectId/analytics': typeof LayoutProjectsProjectIdAnalyticsRoute
  '/projects/$projectId/emails': typeof LayoutProjectsProjectIdEmailsRoute
  '/projects/$projectId/galleries': typeof LayoutProjectsProjectIdGalleriesRoute
  '/projects/$projectId/settings': typeof LayoutProjectsProjectIdSettingsRoute
  '/projects/$projectId/submissions': typeof LayoutProjectsProjectIdSubmissionsRoute
  '/admin/organizations': typeof LayoutAdminOrganizationsIndexRoute
  '/admin/users': typeof LayoutAdminUsersIndexRoute
  '/organizations/$organizationId': typeof LayoutOrganizationsOrganizationIdIndexRoute
  '/projects/$projectId/': typeof LayoutProjectsProjectIdIndexRoute
  '/projects/$projectId/purchase/callback': typeof LayoutProjectsProjectIdPurchaseCallbackRoute
  '/projects/$projectId/purchase/options-callback': typeof LayoutProjectsProjectIdPurchaseOptionsCallbackRoute
  '/projects/$projectId/videos/$videoId': typeof LayoutProjectsProjectIdVideosVideoIdRoute
  '/projects/$projectId/videos': typeof LayoutProjectsProjectIdVideosIndexRoute
}

export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/billing': typeof LayoutBillingRoute
  '/download': typeof LayoutDownloadRoute
  '/help': typeof LayoutHelpRoute
  '/organization': typeof LayoutOrganizationRoute
  '/profile': typeof LayoutProfileRoute
  '/invite/$token': typeof InviteTokenRoute
  '/live/$slug': typeof LiveSlugRoute
  '/p/$alias': typeof PAliasRoute
  '/public/$projectId': typeof PublicProjectIdRoute
  '/s/$slug': typeof SSlugRoute
  '/v/$key': typeof VKeyRoute
  '/': typeof LayoutIndexRoute
  '/projects/new': typeof LayoutProjectsNewRoute
  '/projects': typeof LayoutProjectsIndexRoute
  '/admin/organizations/$orgId': typeof LayoutAdminOrganizationsOrgIdRoute
  '/admin/users/$userId': typeof LayoutAdminUsersUserIdRoute
  '/organizations/$organizationId/members': typeof LayoutOrganizationsOrganizationIdMembersRoute
  '/organizations/$organizationId/webhooks': typeof LayoutOrganizationsOrganizationIdWebhooksRoute
  '/projects/$projectId/analytics': typeof LayoutProjectsProjectIdAnalyticsRoute
  '/projects/$projectId/emails': typeof LayoutProjectsProjectIdEmailsRoute
  '/projects/$projectId/galleries': typeof LayoutProjectsProjectIdGalleriesRoute
  '/projects/$projectId/settings': typeof LayoutProjectsProjectIdSettingsRoute
  '/projects/$projectId/submissions': typeof LayoutProjectsProjectIdSubmissionsRoute
  '/admin/organizations': typeof LayoutAdminOrganizationsIndexRoute
  '/admin/users': typeof LayoutAdminUsersIndexRoute
  '/organizations/$organizationId': typeof LayoutOrganizationsOrganizationIdIndexRoute
  '/projects/$projectId': typeof LayoutProjectsProjectIdIndexRoute
  '/projects/$projectId/purchase/callback': typeof LayoutProjectsProjectIdPurchaseCallbackRoute
  '/projects/$projectId/purchase/options-callback': typeof LayoutProjectsProjectIdPurchaseOptionsCallbackRoute
  '/projects/$projectId/videos/$videoId': typeof LayoutProjectsProjectIdVideosVideoIdRoute
  '/projects/$projectId/videos': typeof LayoutProjectsProjectIdVideosIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_layout/projects': typeof LayoutProjectsRouteRouteWithChildren
  '/_layout/billing': typeof LayoutBillingRoute
  '/_layout/download': typeof LayoutDownloadRoute
  '/_layout/help': typeof LayoutHelpRoute
  '/_layout/organization': typeof LayoutOrganizationRoute
  '/_layout/profile': typeof LayoutProfileRoute
  '/invite/$token': typeof InviteTokenRoute
  '/live/$slug': typeof LiveSlugRoute
  '/p/$alias': typeof PAliasRoute
  '/public/$projectId': typeof PublicProjectIdRoute
  '/s/$slug': typeof SSlugRoute
  '/v/$key': typeof VKeyRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/projects/$projectId': typeof LayoutProjectsProjectIdRouteRouteWithChildren
  '/_layout/projects/new': typeof LayoutProjectsNewRoute
  '/_layout/projects/': typeof LayoutProjectsIndexRoute
  '/_layout/admin/organizations/$orgId': typeof LayoutAdminOrganizationsOrgIdRoute
  '/_layout/admin/users/$userId': typeof LayoutAdminUsersUserIdRoute
  '/_layout/organizations/$organizationId/members': typeof LayoutOrganizationsOrganizationIdMembersRoute
  '/_layout/organizations/$organizationId/webhooks': typeof LayoutOrganizationsOrganizationIdWebhooksRoute
  '/_layout/projects/$projectId/analytics': typeof LayoutProjectsProjectIdAnalyticsRoute
  '/_layout/projects/$projectId/emails': typeof LayoutProjectsProjectIdEmailsRoute
  '/_layout/projects/$projectId/galleries': typeof LayoutProjectsProjectIdGalleriesRoute
  '/_layout/projects/$projectId/settings': typeof LayoutProjectsProjectIdSettingsRoute
  '/_layout/projects/$projectId/submissions': typeof LayoutProjectsProjectIdSubmissionsRoute
  '/_layout/admin/organizations/': typeof LayoutAdminOrganizationsIndexRoute
  '/_layout/admin/users/': typeof LayoutAdminUsersIndexRoute
  '/_layout/organizations/$organizationId/': typeof LayoutOrganizationsOrganizationIdIndexRoute
  '/_layout/projects/$projectId/': typeof LayoutProjectsProjectIdIndexRoute
  '/_layout/projects/$projectId/purchase/callback': typeof LayoutProjectsProjectIdPurchaseCallbackRoute
  '/_layout/projects/$projectId/purchase/options-callback': typeof LayoutProjectsProjectIdPurchaseOptionsCallbackRoute
  '/_layout/projects/$projectId/videos/$videoId': typeof LayoutProjectsProjectIdVideosVideoIdRoute
  '/_layout/projects/$projectId/videos/': typeof LayoutProjectsProjectIdVideosIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/projects'
    | '/billing'
    | '/download'
    | '/help'
    | '/organization'
    | '/profile'
    | '/invite/$token'
    | '/live/$slug'
    | '/p/$alias'
    | '/public/$projectId'
    | '/s/$slug'
    | '/v/$key'
    | '/'
    | '/projects/$projectId'
    | '/projects/new'
    | '/projects/'
    | '/admin/organizations/$orgId'
    | '/admin/users/$userId'
    | '/organizations/$organizationId/members'
    | '/organizations/$organizationId/webhooks'
    | '/projects/$projectId/analytics'
    | '/projects/$projectId/emails'
    | '/projects/$projectId/galleries'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/submissions'
    | '/admin/organizations'
    | '/admin/users'
    | '/organizations/$organizationId'
    | '/projects/$projectId/'
    | '/projects/$projectId/purchase/callback'
    | '/projects/$projectId/purchase/options-callback'
    | '/projects/$projectId/videos/$videoId'
    | '/projects/$projectId/videos'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/billing'
    | '/download'
    | '/help'
    | '/organization'
    | '/profile'
    | '/invite/$token'
    | '/live/$slug'
    | '/p/$alias'
    | '/public/$projectId'
    | '/s/$slug'
    | '/v/$key'
    | '/'
    | '/projects/new'
    | '/projects'
    | '/admin/organizations/$orgId'
    | '/admin/users/$userId'
    | '/organizations/$organizationId/members'
    | '/organizations/$organizationId/webhooks'
    | '/projects/$projectId/analytics'
    | '/projects/$projectId/emails'
    | '/projects/$projectId/galleries'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/submissions'
    | '/admin/organizations'
    | '/admin/users'
    | '/organizations/$organizationId'
    | '/projects/$projectId'
    | '/projects/$projectId/purchase/callback'
    | '/projects/$projectId/purchase/options-callback'
    | '/projects/$projectId/videos/$videoId'
    | '/projects/$projectId/videos'
  id:
    | '__root__'
    | '/_layout'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/_layout/projects'
    | '/_layout/billing'
    | '/_layout/download'
    | '/_layout/help'
    | '/_layout/organization'
    | '/_layout/profile'
    | '/invite/$token'
    | '/live/$slug'
    | '/p/$alias'
    | '/public/$projectId'
    | '/s/$slug'
    | '/v/$key'
    | '/_layout/'
    | '/_layout/projects/$projectId'
    | '/_layout/projects/new'
    | '/_layout/projects/'
    | '/_layout/admin/organizations/$orgId'
    | '/_layout/admin/users/$userId'
    | '/_layout/organizations/$organizationId/members'
    | '/_layout/organizations/$organizationId/webhooks'
    | '/_layout/projects/$projectId/analytics'
    | '/_layout/projects/$projectId/emails'
    | '/_layout/projects/$projectId/galleries'
    | '/_layout/projects/$projectId/settings'
    | '/_layout/projects/$projectId/submissions'
    | '/_layout/admin/organizations/'
    | '/_layout/admin/users/'
    | '/_layout/organizations/$organizationId/'
    | '/_layout/projects/$projectId/'
    | '/_layout/projects/$projectId/purchase/callback'
    | '/_layout/projects/$projectId/purchase/options-callback'
    | '/_layout/projects/$projectId/videos/$videoId'
    | '/_layout/projects/$projectId/videos/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  InviteTokenRoute: typeof InviteTokenRoute
  LiveSlugRoute: typeof LiveSlugRoute
  PAliasRoute: typeof PAliasRoute
  PublicProjectIdRoute: typeof PublicProjectIdRoute
  SSlugRoute: typeof SSlugRoute
  VKeyRoute: typeof VKeyRoute
}

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  InviteTokenRoute: InviteTokenRoute,
  LiveSlugRoute: LiveSlugRoute,
  PAliasRoute: PAliasRoute,
  PublicProjectIdRoute: PublicProjectIdRoute,
  SSlugRoute: SSlugRoute,
  VKeyRoute: VKeyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_layout",
        "/forgot-password",
        "/login",
        "/logout",
        "/register",
        "/reset-password",
        "/invite/$token",
        "/live/$slug",
        "/p/$alias",
        "/public/$projectId",
        "/s/$slug",
        "/v/$key"
      ]
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/projects",
        "/_layout/billing",
        "/_layout/download",
        "/_layout/help",
        "/_layout/organization",
        "/_layout/profile",
        "/_layout/",
        "/_layout/admin/organizations/$orgId",
        "/_layout/admin/users/$userId",
        "/_layout/organizations/$organizationId/members",
        "/_layout/organizations/$organizationId/webhooks",
        "/_layout/admin/organizations/",
        "/_layout/admin/users/",
        "/_layout/organizations/$organizationId/"
      ]
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/_layout/projects": {
      "filePath": "_layout/projects/route.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/projects/$projectId",
        "/_layout/projects/new",
        "/_layout/projects/"
      ]
    },
    "/_layout/billing": {
      "filePath": "_layout/billing.tsx",
      "parent": "/_layout"
    },
    "/_layout/download": {
      "filePath": "_layout/download.tsx",
      "parent": "/_layout"
    },
    "/_layout/help": {
      "filePath": "_layout/help.tsx",
      "parent": "/_layout"
    },
    "/_layout/organization": {
      "filePath": "_layout/organization.tsx",
      "parent": "/_layout"
    },
    "/_layout/profile": {
      "filePath": "_layout/profile.tsx",
      "parent": "/_layout"
    },
    "/invite/$token": {
      "filePath": "invite/$token.tsx"
    },
    "/live/$slug": {
      "filePath": "live/$slug.tsx"
    },
    "/p/$alias": {
      "filePath": "p/$alias.tsx"
    },
    "/public/$projectId": {
      "filePath": "public/$projectId.tsx"
    },
    "/s/$slug": {
      "filePath": "s/$slug.tsx"
    },
    "/v/$key": {
      "filePath": "v/$key.tsx"
    },
    "/_layout/": {
      "filePath": "_layout/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/projects/$projectId": {
      "filePath": "_layout/projects/$projectId/route.tsx",
      "parent": "/_layout/projects",
      "children": [
        "/_layout/projects/$projectId/analytics",
        "/_layout/projects/$projectId/emails",
        "/_layout/projects/$projectId/galleries",
        "/_layout/projects/$projectId/settings",
        "/_layout/projects/$projectId/submissions",
        "/_layout/projects/$projectId/",
        "/_layout/projects/$projectId/purchase/callback",
        "/_layout/projects/$projectId/purchase/options-callback",
        "/_layout/projects/$projectId/videos/$videoId",
        "/_layout/projects/$projectId/videos/"
      ]
    },
    "/_layout/projects/new": {
      "filePath": "_layout/projects/new.tsx",
      "parent": "/_layout/projects"
    },
    "/_layout/projects/": {
      "filePath": "_layout/projects/index.tsx",
      "parent": "/_layout/projects"
    },
    "/_layout/admin/organizations/$orgId": {
      "filePath": "_layout/admin/organizations/$orgId.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin/users/$userId": {
      "filePath": "_layout/admin/users/$userId.tsx",
      "parent": "/_layout"
    },
    "/_layout/organizations/$organizationId/members": {
      "filePath": "_layout/organizations/$organizationId/members.tsx",
      "parent": "/_layout"
    },
    "/_layout/organizations/$organizationId/webhooks": {
      "filePath": "_layout/organizations/$organizationId/webhooks.tsx",
      "parent": "/_layout"
    },
    "/_layout/projects/$projectId/analytics": {
      "filePath": "_layout/projects/$projectId/analytics.tsx",
      "parent": "/_layout/projects/$projectId"
    },
    "/_layout/projects/$projectId/emails": {
      "filePath": "_layout/projects/$projectId/emails.tsx",
      "parent": "/_layout/projects/$projectId"
    },
    "/_layout/projects/$projectId/galleries": {
      "filePath": "_layout/projects/$projectId/galleries.tsx",
      "parent": "/_layout/projects/$projectId"
    },
    "/_layout/projects/$projectId/settings": {
      "filePath": "_layout/projects/$projectId/settings.tsx",
      "parent": "/_layout/projects/$projectId"
    },
    "/_layout/projects/$projectId/submissions": {
      "filePath": "_layout/projects/$projectId/submissions.tsx",
      "parent": "/_layout/projects/$projectId"
    },
    "/_layout/admin/organizations/": {
      "filePath": "_layout/admin/organizations/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin/users/": {
      "filePath": "_layout/admin/users/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/organizations/$organizationId/": {
      "filePath": "_layout/organizations/$organizationId/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/projects/$projectId/": {
      "filePath": "_layout/projects/$projectId/index.tsx",
      "parent": "/_layout/projects/$projectId"
    },
    "/_layout/projects/$projectId/purchase/callback": {
      "filePath": "_layout/projects/$projectId/purchase/callback.tsx",
      "parent": "/_layout/projects/$projectId"
    },
    "/_layout/projects/$projectId/purchase/options-callback": {
      "filePath": "_layout/projects/$projectId/purchase/options-callback.tsx",
      "parent": "/_layout/projects/$projectId"
    },
    "/_layout/projects/$projectId/videos/$videoId": {
      "filePath": "_layout/projects/$projectId/videos/$videoId.tsx",
      "parent": "/_layout/projects/$projectId"
    },
    "/_layout/projects/$projectId/videos/": {
      "filePath": "_layout/projects/$projectId/videos/index.tsx",
      "parent": "/_layout/projects/$projectId"
    }
  }
}
ROUTE_MANIFEST_END */
